import { NetworkConfig } from '@/types';

// 支持的区块链网络配置
export const NETWORKS: Record<number, NetworkConfig> = {
  // BSC Testnet (主要测试网络)
  97: {
    chainId: 97,
    name: 'BSC Testnet',
    rpcUrl: 'https://data-seed-prebsc-1-s1.binance.org:8545',
    explorerUrl: 'https://testnet.bscscan.com',
    contracts: {
      dorToken: '0x61A41405bc2B5F33f925e781fdE64227BA7B5755', // DOR稳定币合约地址 (最新部署)
      stablePool: '0x61A41405bc2B5F33f925e781fdE64227BA7B5755', // 稳定池合约地址 (与DOR合约相同)
      marketPool: '0x61A41405bc2B5F33f925e781fdE64227BA7B5755', // 市场池合约地址 (与DOR合约相同)
      usdtToken: '0x337610d27c682E347C9cD60BD4b3b107C9d34dDd', // BSC测试网USDT
      governance: '0x61A41405bc2B5F33f925e781fdE64227BA7B5755', // 治理合约地址 (与DOR合约相同)
    },
    tokens: {
      usdt: {
        address: '0x337610d27c682E347C9cD60BD4b3b107C9d34dDd',
        decimals: 18,
        symbol: 'USDT',
        name: 'Tether USD'
      }
    }
  },
  
  // Polygon
  137: {
    chainId: 137,
    name: 'Polygon',
    rpcUrl: 'https://polygon-rpc.com',
    explorerUrl: 'https://polygonscan.com',
    contracts: {
      dorToken: '0x...',
      stablePool: '0x...',
      marketPool: '0x...',
      usdtToken: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
      governance: '0x...',
    },
  },
  
  // BSC
  56: {
    chainId: 56,
    name: 'BSC',
    rpcUrl: 'https://bsc-dataseed.binance.org',
    explorerUrl: 'https://bscscan.com',
    contracts: {
      dorToken: '0x...',
      stablePool: '0x...',
      marketPool: '0x...',
      usdtToken: '0x55d398326f99059fF775485246999027B3197955',
      governance: '0x...',
    },
  },
  
  // 测试网络 - Goerli
  5: {
    chainId: 5,
    name: 'Goerli',
    rpcUrl: 'https://goerli.infura.io/v3/YOUR_INFURA_KEY',
    explorerUrl: 'https://goerli.etherscan.io',
    contracts: {
      dorToken: '0x...',
      stablePool: '0x...',
      marketPool: '0x...',
      usdtToken: '0x...',
      governance: '0x...',
    },
  },
  
  // 本地测试网络
  31337: {
    chainId: 31337,
    name: 'Localhost',
    rpcUrl: 'http://localhost:8545',
    explorerUrl: 'http://localhost:8545',
    contracts: {
      dorToken: '0x5FbDB2315678afecb367f032d93F642f64180aa3',
      stablePool: '0xe7f1725E7734CE288F8367e1Bb143E90bb3F0512',
      marketPool: '0x9fE46736679d2D9a65F0992F2272dE9f3c7fa6e0',
      usdtToken: '0xCf7Ed3AccA5a467e9e704C703E8D87F634fB0Fc9',
      governance: '0xDc64a140Aa3E981100a9becA4E685f962fC0B0E9',
    },
  },
};

// 默认网络
export const DEFAULT_NETWORK = NETWORKS[97];

// 获取网络配置
export const getNetworkConfig = (chainId: number): NetworkConfig => {
  return NETWORKS[chainId] || DEFAULT_NETWORK;
};

// 支持的网络列表
export const SUPPORTED_NETWORKS = Object.values(NETWORKS).filter(
  network => network.chainId === 97 // 只支持BSC测试网
);

// 网络切换配置
export const NETWORK_SWITCH_CONFIG = {
  bscTestnet: {
    chainId: '0x61',
    chainName: 'BSC Testnet',
    nativeCurrency: {
      name: 'tBNB',
      symbol: 'tBNB',
      decimals: 18,
    },
    rpcUrls: ['https://data-seed-prebsc-1-s1.binance.org:8545'],
    blockExplorerUrls: ['https://testnet.bscscan.com'],
  },
}; 